/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpsertUserCommand } from '../../models/upsert-user-command';

export interface ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params {
      body?: UpsertUserCommand
}

export function apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue.PATH = '/api/user';
